module.exports = __webpack_public_path__ + "static/img/whitelisted_contact.84779dae.svg";